import Vue from 'vue';
import Vuex from 'vuex';


Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    defaultMetaTitle: 'Bob Pendar-Hughes — Director of Photography',
    defaultMetaDescription: 'Bob Pendar-Hughes is an award-winning commercials and promos director of photography, whose clients include Mercedes, Sony, ITV, Landrover and Walmart.',
    hasLoaded: false,
    showreel: [],
    projects: {},
    groups: {},
    seo: {},
    publicSlugs: [],
    privateSlug: null,
    archive: null,
    pages: {},
  },

  mutations: {

    setData(state, data) {
      state.publicSlugs = data.groups.publicSlugs;
      state.groups = data.groups.bySlug;
      state.showreel = data.groups.bySlug.showreel.projectSlugs;
      state.projects = data.projects.bySlug;
      state.seo = data.seo;
      state.pages = data.pages;
      state.hasLoaded = true;

      if (data.groups.publicSlugs.includes('archive')) {
        state.archive = data.groups.bySlug.archive.projectSlugs;
      }

      if (data.groups.privateSlug) {
        state.privateSlug = data.groups.privateSlug;
      }
    },
  },
});
